import React, {memo} from 'react'
import { strings } from '../../../strings/strings'

export const TravelImportantInfoDescription = memo(() => {

    return (
        <>
            <p><span className='tooltip-important-text'>{strings.travel.forms.importantInfoDesc1}</span></p>
            <p>
                <span>{strings.travel.forms.importantInfoDesc2}</span>
                <span className='tooltip-important-text'>{strings.travel.forms.importantInfoDesc3}</span>
            </p>
            <p>
                <span>{strings.travel.forms.importantInfoDesc4}</span>
                <span className='tooltip-important-text'>{strings.travel.forms.importantInfoDesc5}</span>
            </p>
        </>
    )
})